'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('antd/lib/notification/index');

var _index2 = _interopRequireDefault(_index);

require('antd/lib/notification/style/css');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _Icon = require('../icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _language = require('../language');

require('./index.scss');

require('./notification.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrIcon = {
  0: 'error',
  1: 'success',
  2: 'info',
  3: 'warning',
  4: 'question',
  '': ' '
};

var positions = {
  topCenter: 'toast-top-center',
  topRight: 'toast-top-right',
  topLeft: 'toast-top-left',
  bottomCenter: 'toast-bottom-center',
  bottomRight: 'toast-bottom-right',
  bottomLeft: 'toast-bottom-left'
};

var IDAlert = {
  Swal_confirm: function Swal_confirm(strTitle, strMessage, icon, options) {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var message, html, swal;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              message = strMessage || (0, _language.t)('Message content!');
              html = '<span class="swal2-message" data-testid="' + _lodash2.default.get(options, 'dataTestId', 'alert-' + arrIcon[icon || 0]) + '">' + message + '</span>';
              swal = require('sweetalert2');
              return _context.abrupt('return', swal.fire((0, _extends3.default)({
                title: strTitle || (0, _language.t)('Title'),
                icon: arrIcon[icon || 0],
                html: html,
                showCancelButton: true,
                cancelButtonText: (0, _language.t)('No'),
                confirmButtonText: (0, _language.t)('Yes'),
                dataTestId: 'abc',
                buttons: {
                  cancel: {
                    text: (0, _language.t)('No'),
                    value: null,
                    visible: true,
                    className: '',
                    closeModal: true
                  },
                  confirm: {
                    text: (0, _language.t)('Yes'),
                    value: true,
                    visible: true,
                    className: '',
                    closeModal: true
                  }
                }
              }, options || {})));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  Swal_confirm_input: function Swal_confirm_input(strTitle, strMessage, Icon, required, classInput) {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var swal;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.id = 'input_alert_' + Math.random().toString().replace(/0\./, '');
              swal = require('sweetalert2');
              return _context2.abrupt('return', swal.fire({
                title: strTitle || (0, _language.t)('Title'),
                icon: arrIcon[Icon],
                html: strMessage + '</br><textarea id="' + _this2.id + '" class="' + ('swal2-input ' + classInput) + '"/>',
                showCancelButton: true,
                cancelButtonText: (0, _language.t)('No'),
                confirmButtonText: (0, _language.t)('Yes'),
                buttons: {
                  cancel: {
                    text: (0, _language.t)('No'),
                    value: null,
                    visible: true,
                    className: '',
                    closeModal: true
                  },
                  confirm: {
                    text: (0, _language.t)('Yes'),
                    value: true,
                    visible: true,
                    className: '',
                    closeModal: true
                  }
                },
                preConfirm: function preConfirm() {
                  var value = document.getElementById(_this2.id).value;
                  if (!value && required) {
                    swal.showValidationMessage((0, _language.t)('Please enter data!'));
                    return false;
                  }
                  return value;
                }
              }));

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  Swal_info: function Swal_info(strTitle, strMessage, icon, options) {
    var message = strMessage || (0, _language.t)('Message content!');
    var html = '<span class="swal2-message" data-testid="' + _lodash2.default.get(options, 'dataTestId', 'alert-' + arrIcon[icon || 0]) + '">' + message + '</span>';
    var swal = require('sweetalert2');
    return swal.fire((0, _extends3.default)({
      title: strTitle || (0, _language.t)('Title'),
      icon: arrIcon[icon || 2],
      html: html
    }, options || {}));
  },
  Toast_info: function Toast_info(strTitle, strMessage, icon, options) {
    var placement = 'topRight';
    if (_lodash2.default.get(options, 'position')) {
      options.positionClass = positions[options.position];
      placement = options.position;
      delete options.position;
    } else if (positions[_ConfigGlobal2.default.positionNotification]) {
      placement = _ConfigGlobal2.default.positionNotification;
      options = (0, _extends3.default)({}, options, {
        positionClass: positions[_ConfigGlobal2.default.positionNotification]
      });
    } else {
      options = (0, _extends3.default)({}, options, { positionClass: positions.topRight });
    }
    var message = strMessage || (0, _language.t)('Message content!');
    var description = _react2.default.createElement(
      'span',
      { className: 'swal2-message', 'data-testid': '' + _lodash2.default.get(options, 'dataTestId', 'alert-' + arrIcon[icon || 0]) },
      message
    );

    var config = (0, _extends3.default)({
      message: strTitle || (0, _language.t)('Title'),
      description: description,
      placement: placement
    }, options);
    if (icon === IDAlert.TYPE_ERROR) {
      config.className = 'id-notification notification-error';
      config.icon = _react2.default.createElement(_Icon2.default, { type: 'exclamation-circle', style: { fontSize: 26 } });
    } else if (icon === IDAlert.TYPE_SUCCESS) {
      config.icon = _react2.default.createElement(_Icon2.default, { type: 'safety', style: { fontSize: 26 } });
      config.className = 'id-notification notification-success';
    } else if (icon === IDAlert.TYPE_INFO) {
      config.icon = _react2.default.createElement(_Icon2.default, { type: 'message', style: { fontSize: 26 } });
      config.className = 'id-notification notification-info';
    } else if (icon === IDAlert.TYPE_WARNING) {
      config.icon = _react2.default.createElement(_Icon2.default, { type: 'warning', style: { fontSize: 26 } });
      config.className = 'id-notification notification-warning';
    } else if (icon === IDAlert.TYPE_QUESTION) {
      config.icon = _react2.default.createElement(_Icon2.default, { type: 'question-circle', style: { fontSize: 26 } });
      config.className = 'id-notification notification-question';
    }
    _index2.default.open(config);
  }
};

IDAlert.TYPE_ERROR = 0;
IDAlert.TYPE_SUCCESS = 1;
IDAlert.TYPE_INFO = 2;
IDAlert.TYPE_WARNING = 3;
IDAlert.TYPE_QUESTION = 4;

exports.default = IDAlert;